import React, { useContext, useEffect, useState } from 'react';

// Swagger or ReDoc import
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../configurations/global.config';
import axios from 'axios';
import { useSnackBar } from '../../../contexts/snackbar';

const DocumentationViewer = () => {
  const { user, config } = useContext(AuthContext);
  const { showMessage } = useSnackBar();

  const [swaggerJson, setSwaggerJson] = useState<any | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Fetch the authenticated docs URL on mount
    const fetchDocs = async () => {
      try {
        const response = await axios.get(
          `${API_ENDPOINT}/api/v1/swagger/`,
          config
        );
        setSwaggerJson(response.data);
      } catch (err) {
        showMessage('Failed to get documentation', 'error');
      }
    };

    fetchDocs();
  }, []); // Re-run when the userToken changes

  if (error) {
    return <div>Error: {error} </div>;
  }

  if (!swaggerJson) {
    return <div>Loading documentation...</div>;
  }

  return (
    <div>
      <h2>{user?.type} API Documentation </h2>
      <SwaggerUI
        spec={swaggerJson}
        requestInterceptor={(req) => {
          if (user?.authToken) {
            req.headers['Authorization'] = `Bearer ${user.authToken}`;
          }
          return req;
        }}
      />
    </div>
  );
};

export default DocumentationViewer;
